import { render, staticRenderFns } from "./tableSuratAdmin.vue?vue&type=template&id=16219ee2&scoped=true"
import script from "./tableSuratAdmin.vue?vue&type=script&lang=js"
export * from "./tableSuratAdmin.vue?vue&type=script&lang=js"
import style0 from "./tableSuratAdmin.vue?vue&type=style&index=0&id=16219ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16219ee2",
  null
  
)

export default component.exports